import {
  Container,
  Dropdown,
  Form,
  Nav,
  Navbar,
  NavDropdown,
  Placeholder,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import CTeCode from "./CTe.Code";
import { getLabel } from "src/hook/Functions";
import DatePicker from "react-datepicker";
import { NavDatePicker } from "src/componentes/NavDatePicker/NavDatePicker.Component";
import moment from "moment";
import CTeModalPropriedadesView from "./Modal.Propriedades/CTe.Modal.Propriedades.View";
import CTeModalNovoView from "./Modal.Novo/CTe.Modal.Novo.View";
import { statusEnvioOptions } from "../NFCe/NFCe.Dto";

const CTeView = () => {
  const code = CTeCode();

  return (
    <>
      <Container>
        <HeadPage headText="CT-e" onToggle={code.menu.handleMenuToggleClick}>
          {code.menu.menuItens !== undefined &&
            code.menu.menuItens.map((item) => (
              <Dropdown.Item
                key={item.nome}
                onClick={code.menu.handleMenuClick(item)}
              >
                {item.nome}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!code.loading ? (
          <>
            <Navbar className="bg-body-tertiary justify-content-between">
              <Container>
                <Navbar.Collapse className="justify-content-end">
                  <Nav className="ms-auto">
                    <Form.Control
                      placeholder="Série"
                      className="bg-body-tertiary"
                      onChange={code.handleChangeSerie}
                      value={code.useFilter.filters.serie?.toString() || ""}
                    />
                    <NavDropdown
                      onSelect={code.handleSelectStatus}
                      id="dropdown-codigoStatusEnvio"
                      title={getLabel(
                        statusEnvioOptions,
                        code.useFilter.filters.codigoStatusEnvio,
                        "Status Envio"
                      )}
                    >
                      {statusEnvioOptions.map((option) => (
                        <NavDropdown.Item
                          key={option.value}
                          eventKey={option.value}
                          active={
                            code.useFilter.filters.codigoStatusEnvio ===
                            option.value
                          }
                        >
                          {option.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>

                    <DatePicker
                      locale="pt-BR"
                      selected={code.useFilter.filters.dataEmissaoInicial}
                      onChange={code.handleSetDates}
                      startDate={code.useFilter.filters.dataEmissaoInicial}
                      endDate={code.useFilter.filters.dataEmissaoFinal}
                      selectsRange
                      dateFormat="dd/MM/yyyy"
                      withPortal
                      isClearable={true}
                      className="nav-datepicker"
                      title={code.getDatePickerTitle()}
                      customInput={<NavDatePicker />}
                    />
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
            <Table responsive hover className="mt-2 no-border">
              <tbody>
                {code.data.map((item) => (
                  <tr
                    key={item.id ?? item.numeroCte}
                    style={{ cursor: "pointer" }}
                    onClick={code.handleClickPropriedades(item)}
                  >
                    <td colSpan={5} className="p-0">
                      <div className="border rounded p-2 mb-2">
                        <div className="d-flex align-items-center flex-wrap">
                          <div className="flex-grow-0 me-3 fw-bold">
                            CT-e: {item.numeroCte}
                          </div>

                          <div className="flex-grow-0 me-3">
                            Série: {item.serie}
                          </div>

                          {item.autorizacao && (
                            <>
                              <div className="flex-grow-1 text-truncate me-3">
                                Sefaz: {item.autorizacao.codigoStatusEnvio}-
                                {item.autorizacao.descricaoStatusEnvio}
                              </div>

                              <div className="flex-grow-1 text-truncate d-none d-md-block me-3">
                                {item.autorizacao.codigoStatusResposta}-
                                {item.autorizacao.descricaoMotivoResposta}
                              </div>
                            </>
                          )}

                          <div className="ms-auto text-end">
                            Emissão:{" "}
                            {item.emissaoDataHora
                              ? moment(item.emissaoDataHora).format(
                                  "DD/MM/YYYY HH:mm:ss"
                                )
                              : "-"}
                          </div>

                          <div className="w-100 my-1"></div>

                          <div className="flex-grow-1">
                            <small className="text-muted">Remetente</small>
                            <div className="text-muted">
                              {item.remetente?.nome}
                            </div>
                          </div>

                          <div className="flex-grow-1">
                            <small className="text-muted">Destinatário</small>
                            <div className="text-muted">
                              {item.destinatario?.nome}
                            </div>
                          </div>

                          <div className="text-end">
                            <small className="text-muted">Valor a Receber</small>
                            <div className="text-muted">
                              R${" "}
                              {item.valoresPrestacao?.valorReceber != null
                                ? Number(item.valoresPrestacao.valorReceber).toFixed(2)
                                : "0.00"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        ) : (
          <Placeholder animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Container>

      <CTeModalPropriedadesView
        show={code.modalShowPropriedades}
        cte={code.cte}
        onReturn={code.onReturnModalPropriedades}
        onDelete={code.onDeleteModalPropriedades}
        onDownloadXml={code.onDownloadXml}
        onFetchStatus={code.onFetchStatusModalPropriedades}
        onSend={code.onSendModalPropriedades}
        onEdit={code.onEditModalPropriedades}
        onDuplicate={code.onDuplicateModalPropriedades}
        onPrint={code.onPrintModalPropriedadesImprimir}
        onDownloadDacte={code.onModalPropriedadesDownloadDacte}
        onShareDacte={code.onModalPropriedadesShareDacte}
      />

      <CTeModalNovoView
        show={code.modalNovoShow}
        onContinuar={code.onContinuarModalNovo}
        onCriarNovo={code.onCriarNovoModalNovo}
        onCancel={code.onCancelModalNovo}
      />
    </>
  );
};

export default CTeView;
